import React from 'react';

const PopupInsurance = ({ insurance, t }) =>
  insurance ? (
    <span>{t('checkout.packageInfo.medInsurance.include')}</span>
  ) : (
    <span>{t('checkout.packageInfo.medInsurance.noInclude')}</span>
  );

export default PopupInsurance;
